// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
// Bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// Translate
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '../translate.loader';
// Medsurf Lib
import { MedsurfCommonModule } from '../common/medsurf-common.module';
import { FlatDesignModule } from '@medsurf/flat-designs';
// Components
import { CopyrightDetailComponent } from './copyright-detail/copyright-detail.component';
import { CopyrightsComponent } from './copyrights/copyrights.component';
import { DetachedPagesComponent } from './detached-pages/detached-pages.component';
import { ImportStatsComponent } from './import-stats/import-stats.component';
import { MediaLibraryComponent } from './media-library/media-library.component';
import { MetadataComponent } from './metadata/metadata.component';
import { ModalitiesComponent } from './modalities/modalities.component';
import { ModalityDetailComponent } from './modality-detail/modality-detail.component';
import { StainsComponent } from './stains/stains.component';
import { StainDetailComponent } from './stain-detail/stain-detail.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UsersComponent } from './users/users.component';
import { DateSharedPipe } from '@medsurf/flat-pipes';
import { MatomoStatsComponent } from './matomo-stats/matomo-stats.component';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    RouterModule,
    // Bootstrap
    NgbModule,
    // Translate
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    // Modules
    MedsurfCommonModule,
    FlatDesignModule
  ],
  declarations: [
    // Components
    CopyrightDetailComponent,
    CopyrightsComponent,
    DetachedPagesComponent,
    ImportStatsComponent,
    MediaLibraryComponent,
    MatomoStatsComponent,
    MetadataComponent,
    ModalitiesComponent,
    ModalityDetailComponent,
    StainDetailComponent,
    StainsComponent,
    UserDetailComponent,
    UsersComponent,
  ],
  exports: [
    // Components
    CopyrightDetailComponent,
    CopyrightsComponent,
    DetachedPagesComponent,
    ImportStatsComponent,
    MediaLibraryComponent,
    MatomoStatsComponent,
    MetadataComponent,
    ModalitiesComponent,
    ModalityDetailComponent,
    StainDetailComponent,
    StainsComponent,
    UserDetailComponent,
    UsersComponent,
  ],
  providers: [
    DateSharedPipe,
  ]
})
export class AdminModule {
}
